import React from "react";
import translatedStrings from '../strings/strings.json';

const stringWithLocale = (key, locale) => {
    return translatedStrings.translations
        .find(string => {
            return string.key === key;
        })?.locales
        .find(translation => {
            return translation.locale === locale;
        });
}

export const localeString = (string, locale) => {
    return stringWithLocale(string, locale)?.translation || string;
}

export const LocalizedString = ({ string, locale, className }) => {
    const translation = localeString(string, locale);
    return <span className={className + " translation"} dir={translation.locale === 'heb' ? 'rtl': 'ltr'}>{translation}</span>
}
